import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Module 8 Quiz",
    duration: 15
};

export const module8Questions: QuizQuestion[] = [
    {
        id: "M8-001",
        moduleId: "module-8",
        category: "Expressways",
        text: "Expressways are safer than other roads because ____.",
        options: ["People drive faster", "There is no oncoming traffic or intersections", "Lanes are narrower", "There are more trees"],
        correctAnswer: 1,
        scenario: "A passenger asks you why high-speed expressways are statistically safer than standard local residential streets.",
        explanation: "Expressways physically eliminate oncoming traffic streams and intersection crossings, removing the most dangerous conflict zones on the Grid."
    },
    {
        id: "M8-002",
        moduleId: "module-8",
        category: "Expressways",
        text: "The 'Acceleration Lane' is used to ____.",
        options: ["Pass other cars", "Match the speed of highway traffic", "Wait for a gap", "Exit the highway"],
        correctAnswer: 1,
        scenario: "A thorough pre-drive walk-around allows you to identify **flat tires, fluid leaks, and any people, animals, or objects** hidden in your path of travel. Checking these before starting the engine prevents catastrophic tire blowouts, engine damage from fluid starvation, and tragic back-over accidents.",
        explanation: ""
    },
    {
        id: "M8-003",
        moduleId: "module-8",
        category: "Expressways",
        text: "If you miss your exit on an expressway, you should ____.",
        options: ["Back up on the shoulder", "Make a U-turn across the median", "Continue to the next exit", "Stop and wait"],
        correctAnswer: 2,
        scenario: "You are driving in the left lane of an expressway and suddenly realize you are about to miss your planned exit ramp. What do you do?",
        explanation: "Missed exits must be handled by proceeding to the next exit, safely departing, and doubling back. Never stop, reverse, or cross the median shoulder buffer."
    },
    {
        id: "M8-004",
        moduleId: "module-8",
        category: "Glare",
        text: "To reduce blinding horizontal sun glare at dawn or dusk, you should ____.",
        options: ["Speed up to pass other cars", "Deploy sunglasses and adjust your sun visors", "Turn on your high beams", "Stare directly at the white road shoulder line"],
        correctAnswer: 1,
        scenario: "You are driving East at sunrise, and extreme sun glare completely blinds your view of the road markings ahead. How do you adjust?",
        explanation: "Instantly deploy clean sunglasses and adjust your vehicle's sun visors forward and down. Keep your windshield clean inside and out, as dust scatters light."
    },
    {
        id: "M8-005",
        moduleId: "module-8",
        category: "Laws",
        text: "Ohio law requires you to activate your headlights (not just parking lights) at least ____ before dusk.",
        options: ["15 minutes", "30 minutes", "One hour", "Two hours"],
        correctAnswer: 2,
        scenario: "You are driving home on a clear day as the sun begins to set. When are you legally required to activate your headlights?",
        explanation: "Ohio law mandates that vehicle headlights must be activated from sunset to sunrise, and whenever visibility is reduced to less than 1,000 feet due to rain, snow, or fog."
    },
    {
        id: "M8-006",
        moduleId: "module-8",
        category: "Emergencies",
        text: "If your headlights suddenly go completely black at night, your first emergency step is to ____.",
        options: ["Slam on the brakes immediately", "Toggle the headlight switch to high beams or parking lights", "Steer quickly onto the left shoulder", "Turn off the engine while moving"],
        correctAnswer: 1,
        scenario: "You are traveling on a dark rural highway at night when your headlights suddenly go completely black. How do you maintain control?",
        explanation: "Immediately toggle the headlight switch to high beams, parking lights, or turn on your hazard flashers to regain some illumination and signal your presence."
    },
    {
        id: "M8-007",
        moduleId: "module-8",
        category: "Laws",
        text: "Ohio law mandates that day or night, whenever your vehicle's windshield wipers are in active use, you must also ____.",
        options: ["Turn on your emergency flashers", "Turn on your headlights (not just daytime running lights)", "Set your climate control to maximum defrost", "Maintain a speed of at least 55 MPH"],
        correctAnswer: 1,
        scenario: "It starts to rain lightly during the afternoon, and you turn on your windshield wipers. What is your legal lighting obligation?",
        explanation: "Under Ohio Revised Code, whenever you activate your windshield wipers due to rain, snow, or sleet, you are legally mandated to turn on your low-beam headlights."
    },
    {
        id: "M8-008",
        moduleId: "module-8",
        category: "Traction",
        text: "If you feel your vehicle's steering wheel go light and realize you are hydroplaning, you should ____.",
        options: ["Slam on the brakes immediately", "Grip the wheel firmly, ease off the accelerator, and steer straight", "Jerk the steering wheel in the opposite direction", "Shift your transmission to neutral"],
        correctAnswer: 1,
        scenario: "Your vehicle begins to hydroplane at 50 mph in heavy rain, and the steering wheel feels completely light and disconnected from the road.",
        explanation: "Grip the steering wheel firmly, ease off the accelerator, and keep the wheels pointed straight. Do not slam the brakes or turn the wheel, as this triggers a skid when grip returns."
    },
    {
        id: "M8-009",
        moduleId: "module-8",
        category: "Emergencies",
        text: "In deep standing water, what is the stalling threshold where water can reach the bottom of most passenger cars, flooding the exhaust and stalling the engine?",
        options: ["2 inches", "6 inches", "12 inches", "24 inches"],
        correctAnswer: 1,
        scenario: "You approach a low-lying underpass that is flooded with standing water. What is the stalling threshold for passenger cars?",
        explanation: "Standing water as shallow as 6 inches can reach the exhaust pipe or undercarriage of most passenger cars, flooding the electrical system and stalling the engine."
    },
    {
        id: "M8-010",
        moduleId: "module-8",
        category: "Traction",
        text: "Why are bridges and elevated overpasses typically the first areas of a roadway to freeze and form ice?",
        options: ["They are constructed from porous asphalt", "Cold air circulates both above and below the bridge deck, stripping its heat", "They are exposed to higher wind speeds", "Water flows faster across elevated surfaces"],
        correctAnswer: 1,
        scenario: "You are driving in 34°F rainy weather and approach a concrete highway bridge. Why must you expect ice on the bridge first?",
        explanation: "Bridges freeze first because cold air circulates both above and below the exposed concrete deck, rapidly stripping its thermal energy and forming black ice while asphalt remains wet."
    },
    {
        id: "M8-011",
        moduleId: "module-8",
        category: "Traction",
        text: "At what temperature threshold are icy roads typically the most slippery, and why?",
        options: ["0°F because dry ice has zero friction", "32°F (0°C) because the ice is actively melting, creating a micro-layer of lubricating water", "15°F because tires generate heat and melt the hard surface", "32°F (0°C) because tire tread depth is reduced"],
        correctAnswer: 1,
        scenario: "You are driving in winter weather as the temperature rises from 25°F to 32°F. Why is the roadway suddenly more slippery at the freezing point?",
        explanation: "Roadway ice is most slippery at exactly 32°F because the ice is actively melting, creating a micro-thin layer of lubricating water that completely eliminates tire traction."
    },
    {
        id: "M8-012",
        moduleId: "module-8",
        category: "Preparation",
        text: "To prepare your vehicle for safe winter operation, Ohio law mandates a minimum tire tread depth of ____, and safety experts recommend keeping your gas tank at least ____.",
        options: ["1/32-inch / one-quarter full", "1/16-inch / half full", "1/8-inch / three-quarters full", "2/32-inch / completely full"],
        correctAnswer: 1,
        scenario: "You are preparing your sedan for a winter road trip. What is the Ohio legal minimum tread depth and expert gas safety rule?",
        explanation: "Under Ohio safety rules, winter tires must have a minimum tread depth of 1/16-inch to channel snow, and experts recommend keeping your gas tank at least half full to prevent fuel line freeze-ups."
    },
    {
        id: "M8-013",
        moduleId: "module-8",
        category: "Emergencies",
        text: "If your vehicle becomes stuck in deep snow, what is the correct first mechanical step when performing the 'rocking' procedure to break free?",
        options: ["Spin the tires at high speed in reverse", "Straighten your front wheels, accelerate gently without spinning, and brake at the peak of momentum", "Jerk the steering wheel side-to-side while flooring the accelerator", "Deflate your rear tires completely to increase the contact patch"],
        correctAnswer: 1,
        scenario: "Your tires spin and become stuck in deep snow on a flat street. How do you execute the 'Rocking the Vehicle' method?",
        explanation: "Keep front wheels straight. Shift between Forward and Reverse, accelerating gently at the peak of each direction's momentum, and braking at the crest to build an escape trough."
    },
    {
        id: "M8-014",
        moduleId: "module-8",
        category: "Traction",
        text: "Why is turning on your vehicle's high beam headlights highly dangerous when driving in dense fog or heavy smog?",
        options: ["High beams will overheat and short-circuit the electrical system", "The intense light deflects off suspended moisture droplets, bouncing back and creating a blinding white wall", "High beams generate heat that melts the surrounding fog, producing more water", "High beams project light under the fog layer, causing speed distortion"],
        correctAnswer: 1,
        scenario: "You are driving in dense morning fog. Your passenger suggests you turn on your high-beam headlights to see further ahead.",
        explanation: "High beams project light straight ahead, which reflects off suspended water droplets and scatters back into your eyes, creating a blinding glare. Use low beams only."
    },
    {
        id: "M8-015",
        moduleId: "module-8",
        category: "Senses",
        text: "What is the primary driving safety benefit of performing the 'Auditory Scanning' procedure under low-visibility conditions?",
        options: ["It allows you to hear if your vehicle's transmission is slipping", "It enables you to listen for approaching engines, whistles, or sirens before they can be visually detected", "It calibrates your vehicle's dashboard diagnostic sensor warning beeps", "It helps you scan for speed limit reminders on highway signs"],
        correctAnswer: 1,
        scenario: "You are piloting your vehicle through thick fog with severely limited visibility. Why should you roll down your window slightly?",
        explanation: "In extremely thick fog, rolling down your window and turning off the radio allows you to hear oncoming engines, rail crossing signals, or sirens before they are visible."
    },
    {
        id: "M8-016",
        moduleId: "module-8",
        category: "Emergencies",
        text: "When executing the 'Blackout Protocol' during zero-visibility fog, why must you switch off your vehicle's headlights, parking lights, and emergency flashers after pulling safely off the roadway?",
        options: ["To conserve battery power in case you are stranded for multiple days", "To prevent other motorists in the fog from anchoring onto your lights, assuming you are driving on the road, and rear-ending you", "To allow your vehicle's external proximity sensors to reboot", "To prevent electrical moisture shorts inside your light casings"],
        correctAnswer: 1,
        scenario: "Visibility drops to zero in heavy fog, and you safely pull completely off the roadway onto the shoulder. What must you do with your lights?",
        explanation: "Turn off your tail lights but activate your hazard flashers once safely parked. If you leave your standard lights on, drivers in the fog may 'anchor' onto them and rear-end you."
    },
    {
        id: "M8-017",
        moduleId: "module-8",
        category: "Emergencies",
        text: "Under the 'Blackout Protocol' for dense fog emergency stops, why is taking your foot completely off the brake pedal a critical safety rule?",
        options: ["It prevents your brakes from locking up and overheating", "It ensures your brake lights are turned off, preventing approaching drivers from mistaking your parked car for a moving vehicle and colliding with you", "It resets the vehicle's automatic cruise control memory bank", "It shifts your vehicle's transmission gears automatically into PARK"],
        correctAnswer: 1,
        scenario: "Under Ohio law, teen drivers face strict accountability. If you are **under the age of 18** and receive **two moving violations**, your driver's license will be suspended automatically for **90 days**. If you receive a **third moving violation**, the consequences escalate to a mandatory **one-year license suspension**.",
        explanation: ""
    },
    {
        id: "M8-018",
        moduleId: "module-8",
        category: "Rules",
        text: "Under Ohio law, traffic fines are doubled for any moving or traffic violations committed in which of the following areas?",
        options: ["Designated school zones during arrival hours only", "Active highway construction and work zones", "Municipal parking structures and zones", "Commercial vehicle loading lanes"],
        correctAnswer: 1,
        scenario: "You are driving through a highway construction zone. A sign warns that traffic fines are doubled. When does this apply?",
        explanation: "Under Ohio law, moving violation fines are automatically doubled for offenses committed in active work zones when workers are present, protecting road crews."
    },
    {
        id: "M8-019",
        moduleId: "module-8",
        category: "Traction",
        text: "When operating a vehicle on loose gravel roadways, how do the loose stones affect your vehicle's tires and overall control?",
        options: ["They increase tire contact friction and shorten stopping distance", "They act like thousands of tiny ball bearings rolling under your tires, causing severe traction loss", "They lock the vehicle's brake rotors and trigger the automatic ABS sensor", "They form an organic sticky seal that prevents all lateral swerving"],
        correctAnswer: 1,
        scenario: "You transition from a paved street to a loose gravel rural roadway. How does this surface affect your traction?",
        explanation: "Loose gravel behaves like thousands of tiny ball bearings under your tires, reducing friction. You must reduce your speed and double your following distance immediately."
    },
    {
        id: "M8-020",
        moduleId: "module-8",
        category: "Emergencies",
        text: "Why is exiting a highway tunnel particularly dangerous when traveling in areas prone to high, gusting winds?",
        options: [
            "The sudden transition to natural sunlight causes brief optical blindness",
            "You are suddenly hit by unshielded, high-velocity crosswinds that can cause your vehicle to instantly swerve",
            "The tires lose lateral traction due to sudden change in atmospheric humidity",
            "The vehicle's automatic cruise control system is forced to shut down immediately"
        ],
        correctAnswer: 1,
        scenario: "You are exiting a long mountain highway tunnel at speed. What environmental hazard must you prepare for?",
        explanation: "As you exit the sheltered tunnel, you are suddenly hit by unshielded crosswinds that can push your vehicle. Maintain a firm, two-handed grip on the steering wheel."
    },
    {
        id: "M8-021",
        moduleId: "module-8",
        category: "Hazards",
        text: "What is the primary danger when driving in 'Black Ice' conditions?",
        options: [
            "It causes high-frequency engine vibration",
            "It is a nearly invisible, transparent sheet of ice that blends in with road asphalt, causing sudden skids",
            "It melts at 10 degrees",
            "It is highly reflective and causes extreme solar glare"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Black ice is a thin, transparent layer of ice that forms over black asphalt. Because it is nearly invisible and looks like wet pavement, drivers do not slow down, leading to sudden traction loss.**",
        explanation: ""
    },
    {
        id: "M8-022",
        moduleId: "module-8",
        category: "Hazards",
        text: "When driving in heavy rain, what is the minimum depth of water that can cause your vehicle's tires to hydroplane?",
        options: [
            "1 inch",
            "Less than 1/12 of an inch (just a thin film of water on the roadway)",
            "6 inches",
            "1 foot"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Tires can hydroplane in less than 1/12 of an inch of standing water. If the tire tread cannot channel water away rapidly enough, the rubber lifts off the pavement, losing steering control.**",
        explanation: ""
    },
    {
        id: "M8-023",
        moduleId: "module-8",
        category: "Strategy",
        text: "Why should you avoid using cruise control when driving in wet or icy road conditions?",
        options: [
            "It increases fuel consumption",
            "The system can misinterpret wheel slips and continue accelerating, causing a catastrophic loss of control",
            "It disables the windshield wipers",
            "It triggers the vehicle's alarm system"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Never use cruise control on wet or icy roads. If the tires experience traction loss, the system may detect a speed drop and accelerate, spinning the wheels and causing a severe skid.**",
        explanation: ""
    },
    {
        id: "M8-024",
        moduleId: "module-8",
        category: "Strategy",
        text: "When driving at night, what is the best way to avoid being blinded by oncoming vehicle high-beams?",
        options: [
            "Stare directly at the headlights to adapt your eyes",
            "Turn on your own high beams to match them",
            "Look down and toward the right-hand edge of your lane (the white fog line) to maintain your path of travel",
            "Close your eyes for 2 seconds"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **To avoid temporary blindness from high beams, look down and slightly to the right side of your lane, scanning the white fog line to guide your path of travel while using peripheral vision.**",
        explanation: ""
    },
    {
        id: "M8-025",
        moduleId: "module-8",
        category: "Hazards",
        text: "During a strong wind gust on a highway, which types of vehicles are most susceptible to being pushed out of their lane?",
        options: [
            "Heavy low-profile sports cars",
            "Large, high-profile vehicles like semi-trucks, RVs, and passenger vans",
            "Electric hybrid vehicles",
            "Motorized scooters only"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Large, high-profile vehicles (vans, trucks, trailers) have wide sides that act like sails in high winds, making them extremely susceptible to sudden lateral shifts during gusty highway weather.**",
        explanation: ""
    }
];
